import { Component, Injectable, OnInit } from '@angular/core';
import { Table, TableService } from 'primeng/table';
import { ObjectNames } from '../../crm/constants/constants';
import {FsmTerritoryService} from './territory.service';

@Component({
  selector: 'app-fsm-territory',
  templateUrl: './territory.component.html',
  styleUrls: ['./territory.component.scss'],
  providers: [Table, TableService]
})
export class FsmTerritoryComponent implements OnInit {

  index = 0;
  configMenuItems: any[] = [];


  constructor(private territoryService: FsmTerritoryService) { }

  ngOnInit(): void {
    this.generateConfigMenuItems();
  }

  generateConfigMenuItems(): void{
    this.configMenuItems = [
      {
        label: "Add Type",
        icon: 'pi pi-plus',
        command: () => {
          this.addNewType();
        }
      }
    ];
  }

  getIndex(event) {
    this.index = event.index;
  }

  addNewType(){
    this.index = 1;
    this.territoryService.setType(ObjectNames.BehaviorSubjectVariable);
  }

}
